export default __webpack_public_path__ + "static/media/rug11-min.cd0eb156.jpg";